import React, { Component } from "react";

import dateformat from "dateformat";
import { FileService } from "src/services/file.service";
import PageAnalyticsRowView from "src/legacy/components/Analytics/Page/PageAnalyticsRowView.jsx";
import VideoAnalyticsGraphRowView from "src/legacy/components/Analytics/Video/VideoAnalyticsGraphRowView.jsx";
import AudioAnalyticsGraphRowView from "src/legacy/components/Analytics/Audio/AudioAnalyticsGraphRowView.jsx";

import _ from 'lodash';
import cx from 'classnames'
import styles from "./styles.module.scss";
import { localizedStrings } from 'src/localization/index.jsx';

class AssetShareAnalyticsView extends Component {
  constructor(props) {
    super(props);
    var hasAnalytics = false;
    if (this.props.asset && this.props.asset?.metadata && FileService.hasAnalytics(this.props.asset.metadata)) {
      hasAnalytics = true;
    }

    this.state = {
      pages: [],
      pageCount: 0,
      hasAnalytics: hasAnalytics,
      fetchedAnalytics: false,
      activePage: null,
      chart: {
        width: 250,
        visible: false,
      },
    };

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedConversations = localizedStrings.pages.conversations;
    this.localizedDetails = this.localizedConversations.detail_view;
  }

  componentDidMount() {
    var { contact, share, asset, section } = this.props.location.query;

    if (
      this.props.location.query &&
      !this.state.fetchedAnalytics &&
      this.state.hasAnalytics
    ) {
      this.props.fetchAssetAnalytics(contact, share, section, asset);

      if (this.props.asset) {
        if (FileService.hasPageAnalytics(this.props.asset.metadata)) {
          this.props.fetchPreviewAsset(asset);
        }
      }
      this.setState({
        fetchedAnalytics: true,
      });
    }
  }


  render() {
    return (
      <div className={styles.container}>
        <div className={styles.backButton}>
          <button className={styles.back} onClick={() => window.history.back()}>
            <i className="paperflite-left-arrow" aria-hidden="true"></i>
            <span className={styles.title}>Back</span>
          </button>
        </div>
        <div className={styles.heading}>
          <p> {localizedStrings.formatString(this.localizedDetails.asset_analytics.description, { assetName: this.props.asset?.name })}</p>
        </div>
        {this.renderMetrics()}
        <div>
          <div className={styles.chart}>
            {this.state.hasAnalytics && this.props.asset.analytics.loading && (
              <div className={styles.loadingMessage}>{this.localizedCommonLoading.analytics}...</div>
            )}

            {this.state.hasAnalytics &&
              !this.props.asset.analytics.loading &&
              this.props.asset.events.length == 0 && (
                <div className={styles.emptyMessage}>{this.localizedCommons.no_activity}</div>
              )}

            {this.state.hasAnalytics &&
              !this.props.asset.analytics.loading &&
              this.props.asset.events &&
              this.renderChartAnalytics(this.props.asset.events)}
          </div>
        </div>
      </div>
    );
  }

  renderMetrics() {
    var assetViewEvent = null;
    var downloadViewEvent = null;
    const timeSpent = this.props.asset?.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;
    var analytics = _.get(this.props.asset, 'analytics', null)
    var events = _.get(this.props.asset, 'events', null)

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    if (analytics && events) {
      events.forEach((event) => {
        switch (event.type) {
          case "asset_viewed":
            assetViewEvent = event;
            break;
          case "asset_download":
            downloadViewEvent = event;
            break;

          default:
            break;
        }
      });
    }



    return (
      <div>
        <div className={styles.activityContainer}>
          <div className={styles.metrics}>
            <div className={cx("paperflite-eye", styles.metricsIcon)}></div>
            <div className={styles.metricsText}>
              <label>{assetViewEvent ? assetViewEvent.count : 0}</label>
              <p>{this.localizedCommons.views}</p>
            </div>
          </div>
          <div className={styles.metrics}>
            <div className={cx("paperflite-download", styles.metricsIcon)}></div>
            <div className={styles.metricsText}>
              <label>{downloadViewEvent ? downloadViewEvent.count : 0}</label>
              <p>{this.localizedCommons.downloads}</p>
            </div>
          </div>
          <div className={styles.metrics}>
            <div className={cx("paperflite-history", styles.metricsIcon)}></div>
            <div className={styles.metricsText}>
              <label>{timeSpentValue}</label>
              <p>{this.localizedCommons.time_spent}</p>
            </div>
          </div>
        </div>
        <div className={styles.lastViewed}>
          <p>
            {this.localizedCommons.last_viewed_on} {assetViewEvent ? dateformat(assetViewEvent.createdDate, "dd mmm yyyy") : 'Not yet viewed'}
          </p>
        </div>
      </div>
    );
  }

  renderChartAnalytics(event) {
    var analytics =
      this.props.asset.analytics && this.props.asset.analytics.item;
    if (!analytics) {
      return false;
    }

    if (analytics.type === "PAGE_ANALYTICS") {
      return (
        <PageAnalyticsRowView
          asset={this.props.asset}
          analytics={analytics}
          lastViewedDate={event.createdDate}
          preview={this.props.asset.preview}
          className={styles.pageNumber}
          chartHeight={150}
          renderWithin="conversation"
        />
      );
    } else if (analytics.type == "VIDEO_ANALYTICS") {
      return (
        <VideoAnalyticsGraphRowView
          asset={this.props.asset}
          analytics={analytics}
          lastViewedDate={event.createdDate}
          className={styles.pageNumber}
          renderWithin="conversation"
        />
      );
    } else if (analytics.type === "AUDIO_ANALYTICS") {
      return (
        <AudioAnalyticsGraphRowView
          asset={this.props.asset}
          analytics={analytics}
          lastViewedDate={event.createdDate}
          className={styles.pageNumber}
          renderWithin="conversation"
        />
      );
    }
  }
  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }

    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default AssetShareAnalyticsView;